import { X, CheckCircle2, Loader2, CircleX } from 'lucide-react';
import {useState, useEffect} from "react"


const AssessmentSubmittedPopup = ({
  isOpen = false,
  onClose = () => {},
  result = { status: 'loading', comment: '' }
}) => {

  if (!isOpen) return null;

  // Select UI based on status
  let icon, iconBg, title;
  if (result.status === 'loading') {
    icon = <Loader2 className="w-10 h-10 text-green-600 animate-spin" />;
    iconBg = 'bg-green-100';
    title = 'Submitting your assessment...';
  } else if (result.status === 'failed') {
    icon = <CircleX className="w-10 h-10 text-red-600" />;
    iconBg = 'bg-red-100';
    title = 'You failed the assessment';
  } else if (result.status === 'passed') {
    icon = <CheckCircle2 className="w-12 h-12 text-green-600" />;
    iconBg = 'bg-green-100';
    title = 'Congratulations!';
  }

  return (
    <div
      className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50"
      onClick={result.status !== 'loading'?onClose:undefined}
    >
      <div
        className="bg-white rounded-2xl w-full max-w-md mx-4 relative overflow-hidden"
        onClick={(e) => e.stopPropagation()}
      >
        {/* Close button */}
        {result.status !== 'loading' ?
        <button
          onClick={onClose}
          className="absolute right-4 top-4 text-gray-500 hover:text-gray-700 z-10"
          aria-label="Close"
        >
          <X className="w-6 h-6" />
        </button> :""
        }



        {/* Header */}
        <div className="bg-gray-50 px-8 pt-10 pb-6 rounded-t-2xl border-b">
          <div className="flex flex-col items-center text-center">
            <div
              className={`w-20 h-20 rounded-full ${iconBg} flex items-center justify-center mb-4`}
            >
              {icon}
            </div>
            <h2 className="text-2xl font-semibold text-gray-900">{title}</h2>
            <p className="text-gray-600 mt-2">{result.comment}</p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default AssessmentSubmittedPopup;
